import fetchApi from "../fetchApi";
export const DeleteReport = async (id) => {

    const options = {
        method: 'DELETE',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/company/report/${id}`, options);
};